import {
    REGISTRATION,
    REGISTRATION_SUCCESS,
    REGISTRATION_FAILURE,
    EDIT_REGISTRATION,
    EDIT_REGISTRATION_SUCCESS,
    EDIT_REGISTRATION_FAILURE
} from "../Constants";

const init = {
    get_data: {}
};

const RegistrationReducer = (state = init, action) => {
    switch (action.type) {
        case REGISTRATION:
            return { ...state, loading: true };
        case REGISTRATION_SUCCESS:
            return { ...state, loading: false, get_data: action.payload };
        case REGISTRATION_FAILURE:
            return { ...state, loading: false, get_data: action.payload };
        case EDIT_REGISTRATION:
            return { ...state, loading: true };
        case EDIT_REGISTRATION_SUCCESS:
            return { ...state, loading: false, edit_data: action.payload };
        case EDIT_REGISTRATION_FAILURE:
            return { ...state, loading: false, edit_data: action.payload };
        default:
            return state;
    }
};

export default RegistrationReducer;